import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  users: [],
  isLoading: true,
  viewSingleUser: {},
  isViewModalOpen: false,
  isDeleteModalOpen: false
};

export const getUsers = createAsyncThunk(
  "users/getUsers",
  async (_, thunkAPI) => {
    const response = await axios.get(
      "https://629b40cdcf163ceb8d16b9d9.mockapi.io/users"
    );
    return response.data;
  }
);

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    viewUser: (state, action) => {
      state.isViewModalOpen = true;
      state.viewSingleUser = action.payload;
  
    },
    openDeleteModal: (state, action) => {
      state.isDeleteModalOpen = true;
      state.viewSingleUser = action.payload;
    },
    closeModal: (state) => {
      state.isViewModalOpen = false;
      state.isDeleteModalOpen = false;
      state.viewSingleUser = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.users = action.payload;
    });
    builder.addCase(getUsers.rejected, (state, action) => {
      state.isLoading = true;
      console.error(action.error);
    });
  },
});
export const {viewUser, openDeleteModal, closeModal} = userSlice.actions
export default userSlice.reducer;
